import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionHubWarning from '../../common/SubscriptionHubWarning';
import withRouter from '../../../withRouter';

const ManagementActHub = ({ location, params, navigate }) => (
    <SubscriptionHubWarning
        hubConfigKey="MANAGEMENT_ACT"
        location={location}
        params={params}
        navigate={navigate}
    />
);

ManagementActHub.propTypes = {
    params: PropTypes.shape({}),
    navigate: PropTypes.func,
    location: PropTypes.shape({}),
};

export default withRouter(ManagementActHub);
